"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promotionsDisplaySortFn = exports.getRenderablePromotions = exports.updatePromotion = exports.newPromotion = exports.isDisabled = exports.PromotionDesignation = void 0;
const HIGHLY_RECOMMENDED_PROMOTIONS = ['BCOM_GENIUS_COMMISSION_DISCOUNT', 'BCOM_GENIUS_L2', 'BCOM_GENIUS_L1', 'BCOM_GENIUS_L1_OPTED_IN'];
const RECOMMENDED_PROMOTIONS = ['BCOM_MOBILE_RATES'];
var PromotionDesignation;
(function (PromotionDesignation) {
    PromotionDesignation[PromotionDesignation["RECOMMENDED"] = 0] = "RECOMMENDED";
    PromotionDesignation[PromotionDesignation["HIGHLY_RECOMMENDED"] = 1] = "HIGHLY_RECOMMENDED";
})(PromotionDesignation = exports.PromotionDesignation || (exports.PromotionDesignation = {}));
;
const isDisabled = (promotion) => {
    const { available, cooloff_date } = promotion;
    const isNotCooledOff = !!cooloff_date && new Date() <= new Date(cooloff_date);
    return !available || isNotCooledOff;
};
exports.isDisabled = isDisabled;
const newPromotion = (propertyId, promotionOpportunity) => {
    return {
        channel_id: promotionOpportunity.channel_id,
        property_id: propertyId,
        internal_reference: promotionOpportunity.internal_reference,
        rate: promotionOpportunity.default_rate,
        amount: promotionOpportunity.default_amount,
    };
};
exports.newPromotion = newPromotion;
/**
 *
 * @param propertyId the id of the property in question
 * @param currentlySelectedPromotions list of IPromotion selected for the property
 * @param editedPromotionOpportunity IRenderablePromotionOpportunity that was interacted with
 * @returns A new array of IPromotion | ICreatablePromotion
 */
const updatePromotion = (propertyId, currentlySelectedPromotions, editedPromotionOpportunity) => {
    return editedPromotionOpportunity.selected
        ? [...currentlySelectedPromotions, (0, exports.newPromotion)(propertyId, editedPromotionOpportunity)]
        : currentlySelectedPromotions.filter((promotion) => editedPromotionOpportunity.internal_reference !== promotion.internal_reference);
};
exports.updatePromotion = updatePromotion;
/**
 * Return a sorted set of promotion opportunities <TODOJ>
 * @param propertyPromotions
 * @param promotionOpportunities
 */
const getRenderablePromotions = (propertyPromotions, promotionOpportunities) => {
    const availablePromotions = promotionOpportunities
        .filter((p) => p.is_accepting_signup)
        .sort((a, b) => a.created_at < b.created_at ? -1 : 1);
    const channelsPromotions = availablePromotions.reduce((all, curr) => {
        const channel = curr.channel_id;
        if (!(channel in all)) {
            all[channel] = [];
        }
        const renderable = Object.assign(Object.assign({}, curr), { selected: !!propertyPromotions.find((pro) => pro.internal_reference === curr.internal_reference), disabled: (0, exports.isDisabled)(curr) });
        if (HIGHLY_RECOMMENDED_PROMOTIONS.includes(curr.internal_reference)) {
            renderable.designation = PromotionDesignation.HIGHLY_RECOMMENDED;
        }
        if (RECOMMENDED_PROMOTIONS.includes(curr.internal_reference)) {
            renderable.designation = PromotionDesignation.RECOMMENDED;
        }
        all[channel].push(renderable);
        return all;
    }, {});
    Object.keys(channelsPromotions).forEach((ch) => {
        channelsPromotions[ch].sort(exports.promotionsDisplaySortFn);
    });
    return channelsPromotions;
};
exports.getRenderablePromotions = getRenderablePromotions;
/**
 * TODOJ
 * @param a
 * @param b
 * @returns
 */
const promotionsDisplaySortFn = (a, b) => {
    const { designation: aDes } = a;
    const { designation: bDes } = b;
    if (aDes !== undefined && bDes !== undefined) {
        return aDes > bDes ? -1 : 1;
    }
    if (aDes !== undefined) {
        return -1;
    }
    if (bDes !== undefined) {
        return 1;
    }
    return -1;
};
exports.promotionsDisplaySortFn = promotionsDisplaySortFn;
//# sourceMappingURL=helpers.js.map